import { render, staticRenderFns } from "./ConfirmRoundOverModal.vue?vue&type=template&id=23ae5c7f&scoped=true&"
import script from "./ConfirmRoundOverModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmRoundOverModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRoundOverModal.vue?vue&type=style&index=0&id=23ae5c7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae5c7f",
  null
  
)

/* custom blocks */
import block0 from "./ConfirmRoundOverModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports